import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Button, Card } from '@material-ui/core'
import SingleFileDisplay from '../../Form/SingleFileDisplay'
import { GetApp } from '@material-ui/icons'
import { downloadAll } from '../../../actions/fileActions'
import ToastMessage from '../../ToastMessage/ToastMessage'
import {
  getProjectDetails,
  markProjectAsPaid,
} from '../../../actions/projectActions'
import { PROJECT_MARK_AS_PAID_RESET } from '../../../constants/projectConstants'
import Message from '../../Message/Message'

const ReviewPurchaseOrder = () => {
  const dispatch = useDispatch()
  const [downloadToast, setDownloadToast] = useState(false)
  const [downloadList, setDownloadList] = useState([])
  const [downloadAllDisabled, setDownloadAllDisabled] = useState(true)

  const { project } = useSelector((state) => state.projectDetails)
  const {
    loading: markAsPaidLoading,
    error: markAsPaidError,
    success: markAsPaidSuccess,
  } = useSelector((state) => state.projectMarkAsPaid)

  useEffect(() => {
    let fileList = []

    if (project.purchaseOrderFiles && project.purchaseOrderFiles.length) {
      // eslint-disable-next-line array-callback-return
      project.purchaseOrderFiles.map((file) => {
        fileList.push({ id: file.id, name: file.name })
      })

      setDownloadAllDisabled(fileList.length === 0)
      setDownloadList(fileList)
    }
  }, [project])

  useEffect(() => {
    if (markAsPaidSuccess) {
      dispatch(getProjectDetails(project._id))
      dispatch({ type: PROJECT_MARK_AS_PAID_RESET })
    }
  }, [markAsPaidSuccess, dispatch, project])

  const handleDownloadAllClick = () => {
    setDownloadToast(true)
    dispatch(downloadAll(downloadList))
  }

  const handleMarkAsPaid = () => {
    dispatch(markProjectAsPaid(project._id))
  }

  return (
    <>
      <Card className="p-16">
        <p>Purchase order number: {project.purchaseOrderNumber}</p>

        <div className="flex space-between align-center m-b-8">
          <p className="m-b-0">Purchase order files</p>
          <Button
            color="primary"
            className="small"
            onClick={handleDownloadAllClick}
            disabled={downloadAllDisabled}
          >
            <GetApp style={{ width: 14, marginRight: 5 }} /> Download all
          </Button>
        </div>

        {project.purchaseOrderFiles &&
          project.purchaseOrderFiles.map((file, index) => (
            <SingleFileDisplay file={file} key={index} />
          ))}

        <div className="flex flex-end m-t-16">
          <Button
            variant="contained"
            color="primary"
            onClick={handleMarkAsPaid}
            disabled={markAsPaidLoading}
          >
            Mark as paid
          </Button>
        </div>
        {markAsPaidError && (
          <Message variant="danger">{markAsPaidError}</Message>
        )}
      </Card>
      <ToastMessage
        message={
          <>
            <p className="fs16 fw600">Downloading</p>
            <p className="fs14 m-b-0">
              We are preparing your files for download. Please wait...
            </p>
          </>
        }
        open={downloadToast}
        setOpen={setDownloadToast}
      />
    </>
  )
}

export default ReviewPurchaseOrder
